export const CONTENT_TYPE = { id: 'interactivetextEntry' }
export const MAXLENGTH = 1000
export const PLACEHOLDERTEXT = 'Write here'
export const STATUS_AREA_DATA_TEST_ID_PREFIX = 'text-entry-statusarea-'
export const TEXT_AREA_DATA_TEST_ID_PREFIX = 'text-area-'
export const TEXT_INPUT_DATA_TEST_ID_PREFIX = 'text-input-'
